import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'RedirectLangModal',
  components: {},

  data() {
    return {
      redirectUrl: process.env.VUE_APP_REDIRECT_URL
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      modalData: 'app/modalData'
    }),
    countryName() {
      return this.modalData.redirectLangModal ? this.modalData.redirectLangModal.name : '';
    }
  },
  methods: {
    ...mapMutations({
      modalClose: `app/MODAL_CLOSE`
    }),
    onRedirect() {
      this.modalClose('redirectLangModal');
      // let urlPrefix = this.modalData.redirectLangModal ? this.modalData.redirectLangModal.urlPrefix : '';
      let urlPrefix = 'ru';
      window.open(`${this.redirectUrl}/${urlPrefix}`, '_blank');
      // console.log('onRedirect', `${this.redirectUrl}/${urlPrefix}`);
    },
    onClose() {
      this.modalClose('redirectLangModal');
    }
  }
};
